// Theme configuration for Sleeptronic Maintenance System
// Supports light and dark modes with automatic system preference detection

import { createTheme } from '@mui/material/styles';

const navyBlue = '#1e3a5f';

// Light theme configuration
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: navyBlue,
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    h4: {
      fontWeight: 700,
      marginBottom: '1rem',
    },
    h5: {
      fontWeight: 700,
      marginBottom: '0.75rem',
    },
    h6: {
      fontWeight: 700,
      marginBottom: '0.5rem',
    },
    caption: {
      fontSize: '0.75rem',
      color: '#666666',
      lineHeight: 1.5,
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
        },
      },
    },
  },
});

// Dark theme configuration
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: navyBlue,
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
    text: {
      primary: '#e0e0e0',
      secondary: '#a0a0a0',
    },
  },
  typography: {
    h4: {
      fontWeight: 700,
      marginBottom: '1rem',
    },
    h5: {
      fontWeight: 700,
      marginBottom: '0.75rem',
    },
    h6: {
      fontWeight: 700,
      marginBottom: '0.5rem',
    },
    caption: {
      fontSize: '0.75rem',
      color: '#a0a0a0',
      lineHeight: 1.5,
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottomColor: '#333333',
        },
      },
    },
  },
});
